/**
 * Open external links in a new tab.
 *
 * Any <a> whose resolved hostname differs from the current site's is treated as
 * external and gets target="_blank" plus rel="noopener noreferrer" (the latter
 * prevents tab-nabbing and referrer leak when opening a new tab). Links that
 * already declare a target are left alone, as are non-http(s) schemes
 * (mailto:, tel:, #anchors, javascript:) — a.hostname/protocol are the browser's
 * already-resolved absolute values, so relative and same-host links stay internal.
 */

const isExternal = (a) =>
  (a.protocol === 'http:' || a.protocol === 'https:') && a.hostname !== window.location.hostname

// Exported so it can run again over client-injected markup if ever needed;
// safe to re-run (already-marked links have a target and are skipped).
export const markExternalLinks = (root = document) => {
  root.querySelectorAll('a[href]:not([target])').forEach((a) => {
    if (!isExternal(a)) return
    a.target = '_blank'
    const rel = new Set((a.rel || '').split(/\s+/).filter(Boolean))
    rel.add('noopener')
    rel.add('noreferrer')
    a.rel = [...rel].join(' ')
  })
}

markExternalLinks()
